
import('../scripts/tabsSwitcher');
